import RequestAbstract from "../abstract";

/**
 * Wallet rules: a gateway's wallet payin / payout rule, whose filterRule core
 * evaluates for every candidate wallet. A filterRule that does not compile for the
 * rule's kind is refused on save (422 `WALLET_RULE_INVALID: …`); orderRule is not
 * evaluated yet.
 */
export default class PublicWalletRules extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-wallet-rules";
    }

    /**
     * Every variable a rule may read, for the editor's help
     * (`[{ name, type, kinds, source, failureSlot, dayRange, description }]`): the
     * same list the cabinet checks a filterRule's names against.
     */
    async variables() {
        return await this.loadWithAuth(`${this.link}/variables`, { method: 'GET' });
    }

}
